import { useGeolocation } from "@vueuse/core";
import api from "@/api/config";
import { GeofenceResponseData } from "@/data/interfaces/Geofence";
import { i18n } from "@/i18n/i18n";

export const { isSupported, coords, resume, error } = useGeolocation();

export const matchesTerminalId = (
  terminalId: string,
  terminalCountryCode: string,
  data: GeofenceResponseData[]
) => {
  // info: this ticket is only about what happens if terminalId matches. The no-match case will be handled in another ticket.
  return data?.find((geofence) => {
    if (geofence?.metadata?.subdescription) {
      const subdescription = geofence.metadata.subdescription;
      const subdescription_arr = subdescription.split("_");
      if (subdescription_arr.length > 1 && subdescription_arr[0] == "ts") {
        if (subdescription_arr.length == 3) {
          const subdescription_country_code = subdescription_arr[1];
          const subdescription_terminalId = subdescription_arr[2];
          return (
            subdescription_terminalId === terminalId &&
            subdescription_country_code == terminalCountryCode
          );
        }
      }

      // if subdescription == "", ignore
    }
    return false;
    // if there is no subdescription, ignore
  });
};

export const geofencesMatchTerminalId = async (
  terminalId: string,
  terminalCountryCode: string
) => {
  // const geoLocationPermissionAllowed = confirm(
  //   i18n.global.t("main.geolocation-permission")
  // );

  const geoLocationPermissionAllowed =
    error.value == null && coords.value.accuracy != 0;
  const localStorageCoords = localStorage.getItem("coords");
  let { latitude, longitude } = { latitude: 0, longitude: 0 };
  if (localStorageCoords) {
    const localStorageCoordsParsed = JSON.parse(localStorageCoords);
    latitude = localStorageCoordsParsed?.latitude;
    longitude = localStorageCoordsParsed?.longitude;
  } else {
    latitude = coords.value.latitude;
    longitude = coords.value.longitude;
  }
  if (geoLocationPermissionAllowed) {
    const response = await api.get("/api/geofence", {
      params: {
        latitude,
        longitude,
        terminalId,
        terminalCountryCode,
      },
    });
    const geofenceData: GeofenceResponseData[] = response?.data?.geofences;
    if (geofenceData) {
      return matchesTerminalId(terminalId, terminalCountryCode, geofenceData);
    }
    return false;
  } else {
    console.error("Geolocation permission denied.");
    geofencesResume();
    return false;
  }
};

export const geofencesResume = async () => {
  const { resume } = useGeolocation();
  resume();
};
